import React from 'react';
import { Fade } from 'react-reveal';
import DegreeCard from './degreeCard/DegreeCard';
import './Degree.css';

const Degree = () => {
  return (
    <div className='main'>
      <div className='degree-header-div'>
        <Fade bottom duration={2000} distance='20px'>
          <h1 className='degree-header'>Degree Received</h1>
        </Fade>
      </div>
      <div className='degree-body-div'>
        <DegreeCard />
      </div>
    </div>
  );
};

export default Degree;
